module.exports = __webpack_public_path__ + "img/file-text.430d35c7.svg";